import React from 'react';

/**
 * Circles Logo - Two interconnected circles
 * Web version using standard SVG
 */
export default function CirclesLogo({ size = 32, color = '#111' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Right: Outer arc (filled) */}
      <path 
        d="M14.92,16.72c2.69.92,6.1-1.5,6.12-4.41.19-2.8-2.16-5.14-4.97-5.16-.47-.01-.85.07-1,.28-.24.31.05,1,.23,1.53.79,2.38.47,5-.47,7.27-.02.13-.03.29.03.42l.06.07Z" 
        fill={color} 
        stroke={color} 
        strokeLinecap="round" 
        strokeMiterlimit="10" 
        strokeWidth="1.2"
      />
      {/* Right: Inner arc (concentric, shorter) */}
      <path 
        d="M12.35,18.12c1.18.72,2.57,1.11,4.05,1.04,3.96-.17,7.03-3.52,6.85-7.48s-3.52-7.03-7.48-6.85c-1.26.05-2.42.43-3.43,1.04" 
        fill="none" 
        stroke={color} 
        strokeLinecap="round" 
        strokeMiterlimit="10" 
        strokeWidth="0.9"
      />
      {/* Left: Complete circle (filled) */}
      <circle 
        cx="7.22" 
        cy="11.89" 
        r="6.03" 
        fill={color} 
        stroke={color} 
        strokeLinecap="round" 
        strokeMiterlimit="10" 
        strokeWidth="1.2"
      />
    </svg>
  );
}
